import { Button, Card, Dialog, Fab, Grid, withTheme, WithTheme } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AscendState } from '../../ducks';
import { FETCH_ACCOUNTS } from '../../ducks/actions';
import routerHistory from '../../history';
import { MxAccount } from '../../models/mx';
import { MxTransaction } from '../../models/mx';
import { UPDATE_DUMMY_DATA_VISIBILITY, UPDATE_DUMMY_PAYOFF_VISIBILITY } from '../../ducks/actions';

import Layout from '../Layout/Layout';
import Title from '../shared/Title/Title';
import AddTransactionDialog from './AddTransactionDialog';
import CashFlowTable from './CashFlowTable';
import CategoriesTable from './CategoriesTable';
import SpendingHowToSection from './SpendingHowToSection';
import TransactionsTable from './TransactionsTable';
import { getSortedMxTransactions } from '../../ducks/mx';
import { dummyTransactions } from '../dummyData/dummyTransactions';

type StateProps = {
  accounts: MxAccount[];
  transactions: MxTransaction[];
  transactionsLoading: boolean;
  userId: number;
  showDummyData: boolean;
};
type DispatchProps = {
  getAccounts: (userId: number) => void;
  updateDummyDataVisibility: (userId: number) => void;
  updateDummyPayoffVisibility: (userId: number) => void;
};
type SpendingTrackerProps = StateProps & DispatchProps & WithTheme;

// todo I'd like to automatically redirect to accounts page if user has no accounts,
//  maybe in a useEffect that waits for accounts to load

const SpendingTracker = ({
  accounts,
  getAccounts,
  updateDummyDataVisibility,
  theme,
  transactions,
  transactionsLoading,
  userId,
  showDummyData,
}: SpendingTrackerProps) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const showHeader = showDummyData; // conditionally show the spending how to section tied to showDummyData currently

  if (showDummyData) {
    transactions = dummyTransactions;
  }

  const hasTransactions = transactions.length > 0;

  useEffect(() => {
    if (!transactionsLoading) handleClose();
  }, [transactionsLoading]);

  useEffect(() => {
    if (!userId) return;
    getAccounts(userId);
  }, [userId]);

  return (
    <Layout>
      {showHeader ? <SpendingHowToSection /> : ''}
      {showDummyData ? (
        <div style={{ textAlign: 'center' }}>
          <Button
            size="large"
            variant="contained"
            color="secondary"
            onClick={() => {
              updateDummyDataVisibility(userId);
            }}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: '20px',
              marginBottom: '-40px',
              backgroundColor: '#EF6551',
            }}>
            Remove Example Transactions
          </Button>
        </div>
      ) : (
        ''
      )}
      <Title text="Spending Tracker" center />
      <Fab
        color="primary"
        onClick={handleOpen}
        style={{
          position: 'fixed',
          bottom: theme.spacing.unit * 2,
          right: theme.spacing.unit * 2,
        }}>
        <Add />
      </Fab>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <AddTransactionDialog onClose={handleClose} />
      </Dialog>
      <Grid container spacing={16}>
        <Grid item xs={12} md={6} lg={4}>
          <CashFlowTable />
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={() => routerHistory.push('/accountsTracker')}
            style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' }}>
            View Accounts
          </Button>
          <Button
            size="large"
            variant="contained"
            color="secondary"
            onClick={handleOpen}
            style={{ marginTop: '20px', marginBottom: '20px' }}>
            Add Transactions
          </Button>
          {hasTransactions && <CategoriesTable />}
        </Grid>
        <Grid item xs={12} md={6} lg={8}>
          <Card elevation={2}>
            <TransactionsTable />
          </Card>
        </Grid>
      </Grid>
    </Layout>
  );
};

const mapStateToProps = (state: AscendState) => ({
  accounts: state.mx.accounts.data,
  connectUrl: state.mx.connectUrl.data,
  members: state.mx.members.data,
  transactionsLoading: state.mx.transactions.loading,
  userId: state.user.data.id,
  transactions: getSortedMxTransactions(state),
  showDummyData: state.user.data.showDummyData,
});

// noinspection JSUnusedGlobalSymbols
const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAccounts: (userId: number) => dispatch({ type: FETCH_ACCOUNTS, userId }),
  updateDummyDataVisibility: (userId: number) =>
    dispatch({ type: UPDATE_DUMMY_DATA_VISIBILITY, payload: { userId } }),
  updateDummyPayoffVisibility: (userId: number) =>
    dispatch({ type: UPDATE_DUMMY_PAYOFF_VISIBILITY, payload: { userId } }),
});

export default withTheme()(
  connect<StateProps, DispatchProps, {}>(mapStateToProps, mapDispatchToProps)(SpendingTracker)
);
